import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=39dc4e08&"
import script from "./HelpDetail.vue?vue&type=script&lang=js&"
export * from "./HelpDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports